var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "M0 0h23v23H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f35325",
    d: "M1 1h10v10H1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#81bc06",
    d: "M12 1h10v10H12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#05a6f0",
    d: "M1 12h10v10H1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffba08",
    d: "M12 12h10v10H12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.72f0fcc7.svg";
export { ForwardRef as ReactComponent };